import { TreeSelect } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { TreeSelectBox } from '../../models/donvi/DonVi';
import { layDanhSachDonVi } from '../../services/donvi';
import { arrayCommon } from '../../helpers/common';

const DonViSelectTree = ({ name, value, optionAll, noChoose, disabled, donViQuanLy, onChange, allowClear, autoSelectFirst = true }: { name?: string, value?: number, optionAll?: boolean, noChoose?: boolean, disabled?: boolean, donViQuanLy?: boolean, onChange?: (e: any) => void, allowClear?: boolean, autoSelectFirst?: boolean }) => {

    const [data, setData] = useState<Array<TreeSelectBox>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const valueRef = useRef(value);
    valueRef.current = value;
    const dsDonVi = async () => {
        setIsLoading(true);
        try {
            let rs = await layDanhSachDonVi(donViQuanLy || false);
            if ((rs || []).length == 0) {
                rs = [
                    {
                        value: -1,
                        title: "--Không có dữ liệu--",
                        children: []
                    },
                ];
            }
            if (optionAll) {
                rs.unshift({
                    "value": 0,
                    "title": "--Tất cả--",
                    "children": []
                });
            }
            if (noChoose) {
                rs.unshift({
                    "value": 0,
                    "title": "--Không có đơn vị--",
                    "children": []
                });
            }
            setData(rs);
            let hienTai = valueRef.current;
            let opt = arrayCommon.findByValue(rs, hienTai);
            if ((hienTai == null || hienTai == undefined) && (opt == null || opt == undefined)) {
                if (autoSelectFirst && onChange) {
                    onChange({
                        target: {
                            name: name,
                            value: rs[0].value
                        }
                    });
                }
            }

        }
        catch (error: any) {
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        dsDonVi();
    }, []);
    return (
        <TreeSelect
            showSearch={true}
            filterTreeNode={function (search, item: any) {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={data}
            placeholder="--Chọn đơn vị, phòng ban--"
            treeDefaultExpandAll
            loading={isLoading}
            style={{ width: "100%" , height: "35px"}}
            onChange={(e: number) => {
                if (onChange) {
                    onChange({
                        target: {
                            name: name,
                            value: e
                        }
                    });
                }
            }}
            disabled={disabled}
            allowClear={allowClear}
        />
    );
};

export default DonViSelectTree;
